import { render, staticRenderFns } from "./ParameterIssues.vue?vue&type=template&id=59f10234&"
import script from "./ParameterIssues.vue?vue&type=script&lang=ts&"
export * from "./ParameterIssues.vue?vue&type=script&lang=ts&"
import style0 from "./ParameterIssues.vue?vue&type=style&index=0&id=59f10234&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports